import styled from 'styled-components';
import React from 'react';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';
import { navigate } from 'gatsby';

const SectionOne = styled.div`
  background-repeat: no-repeat;
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
  background: black;
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 2rem !important;
  }
  width: 100%;
  display: grid;
`;
const SectionItemContainer = styled.div`
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    padding-left: 0rem;
  }
`;

const HeroSubTitle = styled(SectionParent)`
  padding-top: 1.5rem;
  /* margin-left: 3rem;
  margin-right: 3rem; */
  padding: 0 14rem;
  width: 90%;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  /* text-shadow: 0px 1px #000000; */
  letter-spacing: normal;
  color: #ffffff;
  text-align: center;
  max-width: 64rem;
  @media (max-width: 1440px) and (min-width: 780px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    line-height: 1.5;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 24px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

export default class CustomHardwareSectionTwo extends React.Component<
  any,
  any
> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <SectionOne>
        <SectionItemContainer>
          <HeroSubTitle style={{ paddingTop: '1rem' }}>
            <div>
              Based on Esper’s market research, over 200 million
              enterprise-ready Android devices will be deployed in the next 5
              years. Enterprises are stuck between non-customizable, off the
              shelf devices or sourcing custom device from unknown vendors.
            </div>
            <div style={{ marginTop: '1rem' }}>
              The solution? MediaTek offers a customizable Android AOSP with the
              Esper device cloud platform as a baseline enabling enterprises to
              validate the use case in a matter of weeks.
            </div>
          </HeroSubTitle>
          <BlueButtonWrapper>
            <BlueButton
              id="custom_hardware__signup_2"
              onClick={() => navigate('/signup')}
              style={{
                marginLeft: '0',
              }}
            >
              Sign up with Esper
            </BlueButton>
          </BlueButtonWrapper>
        </SectionItemContainer>
      </SectionOne>
    );
  }
}
